export enum ECompositingOperation {
  DARKEN,
  LIGHTEN,
}
